import { picoapp } from 'picoapp'

// snippets
import accountLogin from '@/snippets/accountLogin.js'
import cart from '@/snippets/cart.js'
import cartRedirect from '@/templates/cart-redirect.js'
import contentAccordion from '@/snippets/content-accordion.js'
import footer from '@/snippets/footer.js'
import formatLinks from '@/snippets/format-links.js'
import header from '@/snippets/header.js'
import heroVideo from '@/snippets/hero-video.js'
import featuredCarousel from '@/snippets/featured-carousel.js'
import asSeenInCarousel from '@/snippets/as-seen-in-carousel.js'
import productCard from '@/snippets/product-card.js'
import productDetails from '@/snippets/product-details.js'
import productCounter from '@/snippets/product-counter.js'
import scroll from '@/snippets/scroll.js'
import faqScroll from '@/snippets/faq-scroll.js'
import subscribe from '@/snippets/subscribe.js'

// state
const state = {
  router: null,
  pjax: false,
  cartOpen: false,
  loadURL: ''
}

// components
const components = {
  accountLogin,
  cart,
  cartRedirect,
  contentAccordion,
  footer,
  formatLinks,
  header,
  heroVideo,
  featuredCarousel,
  asSeenInCarousel,
  productCard,
  productDetails,
  productCounter,
  scroll,
  faqScroll,
  subscribe
}

export default picoapp(components, state)
